export default (() => {
  const { NODE_ENV, REACT_APP_ENV } = process.env;

  return REACT_APP_ENV || NODE_ENV;
})();
